import { Controller } from "@hotwired/stimulus"

// Выбор срока ручного изменения отгрузки: количество дней или дата окончания (включительно).
// Неактивное поле скрывается и отключается, чтобы не уходить на сервер.
export default class extends Controller {
  static targets = ["mode", "days", "date"]

  connect() {
    this.toggle()
  }

  toggle() {
    const byDate = this.modeTargets.find((el) => el.checked)?.value === "date"
    this.setActive(this.daysTarget, !byDate)
    this.setActive(this.dateTarget, byDate)
  }

  setActive(wrapper, active) {
    wrapper.classList.toggle("d-none", !active)
    wrapper.querySelectorAll("input").forEach((input) => {
      input.disabled = !active
      input.required = active
    })
  }
}
